module.exports = __webpack_public_path__ + "img/heart_significance.7e015102.png";